import Link from 'next/link';
import { Media, ProductType } from '#types/generated/graphql-types';
import Button from '#components/controls/button/Button';
import Typography from '#components/typography/Typography';
import IconButton from '#components/controls/icon-button/IconButton';
import { PlayCircleOutlined } from '#components/icons';
import { ContinueWatchingItem } from '#store/namespaces/continue-watching/state';
import useTranslation from 'next-translate/useTranslation';
import { getRoute } from '#utils';
import shouldShowPlayButton from '#utils/shouldShowPlayButton';
import shouldShowRentButton from '#utils/shouldShowRentButton';

type Props = {
  item: Media;
  continueWatchingState: ContinueWatchingItem;
  onPlayButtonClick: (item: Media) => void;
  onProductButtonClick: (mediaIri, productIri) => void;
};

const EpisodeItemSmall = ({
  item,
  onPlayButtonClick,
  continueWatchingState,
  onProductButtonClick,
}: Props) => {
  const { t, lang } = useTranslation();
  const duration = continueWatchingState?.mediaDuration;
  const time = continueWatchingState?.currentTime;

  const rentProduct = item?.products?.availableProducts?.find(
    (product) => product.type === ProductType.Rent
  );

  return (
    <div className="tw-flex tw-mb-1.5" style={{ backgroundColor: '#11151f' }}>
      <div className="tw-shrink-0 tw-px-4 tw-flex tw-justify-center tw-items-center">
        {shouldShowPlayButton(item?.products) === true && (
          <IconButton
            size="medium"
            transparent
            onClick={() => onPlayButtonClick(item)}
          >
            <PlayCircleOutlined
              size={30}
              duration={duration || 10}
              time={time || 0}
            />
          </IconButton>
        )}
      </div>
      <div className="tw-py-4 tw-flex tw-flex-col tw-grow tw-overflow-hidden">
        <Link href={getRoute(item, t)} passHref={true}>
          <Typography fontWeight="bold" element="a">
            {t('seriesPageEpisodeItemTitleSmallScreen', {
              episodeNumber: item.episodeNumber,
            })}
            <Typography fontSize="small" classes="tw-truncate">
              {item.title}
            </Typography>
          </Typography>
        </Link>
      </div>
      <div className="tw-px-8 tw-flex tw-shrink-0 tw-items-center">
        {shouldShowRentButton(rentProduct, item?.products?.access) && (
          <Button
            size="small"
            key={rentProduct.id}
            title={`${Number(rentProduct.price / 100).toLocaleString(lang, {
              style: 'currency',
              currency: 'EUR',
            })}${'\u00B9'}`}
            onClick={() => onProductButtonClick(item.iri, rentProduct.iri)}
          />
        )}
      </div>
    </div>
  );
};

export default EpisodeItemSmall;
